import { GetListRequestParams, GetListResponse, instance } from "libs/api";

import { ApiRoutesInsights } from "../../constants";
import { NeverSoldProductsListItem } from "../../insights.types";

export const requestNeverSoldProducts = async (
  params: GetListRequestParams
): Promise<GetListResponse<NeverSoldProductsListItem>> => {
  return await instance.get(ApiRoutesInsights.NeverSoldProducts, {
    params
  });
};
